import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-xs-comunicado',
  templateUrl: './xs-comunicado.component.html',
  styleUrls: ['./xs-comunicado.component.css']
})
export class XsComunicadoComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<XsComunicadoComponent>,) { }

  ngOnInit() {
  }
  onClickCerrar() {
    this.dialogRef.close({ data: null, estado: "CERRAR" });
  }
}
